import { defineMessages } from 'react-intl';

const scope = 'cb.screens.ReferralProgramForm';

export default defineMessages({
  earnPoints: {
    id: `${scope}.earnPoints`,
    defaultMessage: 'Earn { earnedPoints, plural, one {# point} other {# points}}',
  },
  forEachMember: {
    id: `${scope}.forEachMember`,
    defaultMessage: 'for each paid membership referral',
  },
  pointsToMoney: {
    id: `${scope}.pointsToMoney`,
    defaultMessage: '100 points = $1 CAD',
  },
  pointsDescription: {
    id: `${scope}.pointsDescription`,
    defaultMessage: 'Points can be used to purchase products and services from our participating coupons',
  },
  finishAgreement: {
    id: `${scope}.finishAgreement`,
    defaultMessage: 'By clicking Finish you agree to our <termsLink>Terms of Service</termsLink> and <policyLink>Privacy Policy</policyLink>',
  },
  finishBtn: {
    id: `${scope}.finishBtn`,
    defaultMessage: 'Finish',
  },
});
